import React, { FC, forwardRef, ForwardRefRenderFunction } from "react";
import * as SC from "./styles";
import { Year } from "../../models/history";
import { useTranslation } from "../../i18n";

type Props = {
  yearInfo: Year;
  yearImage:
    | "/static/images/circles.svg"
    | "/static/images/circles-inactive.svg";
  isReversed?: boolean;
  isActive?: boolean;
  href?: string;
};

function pluralRu(count, one, few, many) {
  const mod10 = count % 10;
  const mod100 = count % 100;

  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return few;
  return many;
}

const YearCard: ForwardRefRenderFunction<HTMLAnchorElement, Props> = (
  { yearInfo, yearImage, isReversed = false, isActive = false, href },
  ref
) => {
  const { t, i18n } = useTranslation("news");

  // В ru счётчик подписан как «тыс. гостей», в en — просто «guests»,
  // поэтому для en число разворачиваем до полного.
  const guestCount = `${yearInfo.guest_count}${
    i18n.language === "en" ? "\u00A0000" : ""
  }`;

  return (
    <SC.YearCardRoot
      isActive={isActive}
      isReversed={isReversed}
      href={href}
      ref={ref}
    >
      <SC.Img src={yearImage} alt={`${yearInfo.year}`} />
      <SC.Text>
        <SC.Title>{yearInfo.year}</SC.Title>
        <SC.Span>{`${guestCount}\u00A0${t("guests")}`}</SC.Span>
        <SC.Span>{`${yearInfo.scene_count} ${pluralRu(
          yearInfo.scene_count,
          t("scene_one"), // 1
          t("scene_few"), // 2-4
          t("scene_many") // 5+
        )}`}</SC.Span>
        <SC.Span>{`${yearInfo.artist_count}\u00A0${t("musicians")}`}</SC.Span>
        {yearInfo.extra_info && (
          <SC.Text
            dangerouslySetInnerHTML={{
              __html: yearInfo.extra_info,
            }}
          />
        )}
      </SC.Text>
    </SC.YearCardRoot>
  );
};

export default forwardRef(YearCard);
